/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
 */
export interface ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina {
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  name?: string | null;
  /**
   *
   * @type {CredentialRead}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  domain?: string;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina interface.
 */
export function instanceOfConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina(
  value: object,
): value is ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSON(
  json: any,
): ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina {
  return ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina {
  if (json == null) {
    return json;
  }
  return {
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
  };
}

export function ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaToJSON(
  value?: Omit<ConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
  };
}
